import type { CartApiResponse, CartStateData } from '../types';
import { formatCartState } from './formatCartState';
import appStore from './state';
import { syncFreeGift } from './syncFreeGift';

export const updateCart = async (lineItemKey: string, quantity: number): Promise<CartStateData | undefined> => {
  appStore.actions.setCartUpdating(true);

  try {
    // @ts-expect-error Shopify is injected on the storefront
    const response = await fetch(`${window.Shopify.routes.root}cart/change.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        id: lineItemKey,
        quantity,
        sections: 'cart-drawer,giftbox-modal',
      }),
    });

    if (!response.ok) {
      throw new Error(`Cart change failed (${response.status})`);
    }

    const data = (await response.json()) as CartApiResponse;
    const synced = (await syncFreeGift(data)) ?? data;

    const cartData: CartStateData = formatCartState(synced);

    appStore.actions.setCart(cartData);

    return cartData;
  } catch (error) {
    console.error(error);
    return undefined;
  } finally {
    appStore.actions.setCartUpdating(false);
  }
};
